/* ── Cart mutation interceptor (works with ReCharge / any third-party cart) ── */
(function () {
  var CART_MUTATE = /\/cart\/(add|change|update|clear)\.js/;
  var _fetch = window.fetch;

  function broadcastCartChange() {
    _fetch.call(window, Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:external-change', {
          bubbles: true,
          detail: { cart: cart }
        }));
      });
  }

  window.fetch = function () {
    var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
    var isCartMutation = CART_MUTATE.test(url);
    var result = _fetch.apply(this, arguments);
    if (isCartMutation) {
      result.then(function () {
        setTimeout(broadcastCartChange, 300);
      });
    }
    return result;
  };

  var _xhrOpen = XMLHttpRequest.prototype.open;
  var _xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._isCartMutation = CART_MUTATE.test(url);
    return _xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this._isCartMutation) {
      this.addEventListener('load', function () {
        setTimeout(broadcastCartChange, 300);
      });
    }
    return _xhrSend.apply(this, arguments);
  };
})();

document.addEventListener('click', function (e) {

  const card = e.target.closest('product-card');
  if (!card) return;

  // Make sure it's inside <product-list>
  if (!card.closest('product-list')) return;

  // Ignore interactive elements
  if (
    e.target.closest('button') ||
    e.target.closest('form') ||
    e.target.closest('input') ||
    e.target.closest('select') ||
    e.target.closest('textarea') ||
    e.target.closest('a')
  ) {
    return;
  }

  const link = card.querySelector('.product-card__title a[href]');
  if (!link) return;

   window.location.href = link.href;

});

function ruggedDogProductFormSellingPlanId(form) {
  if (!form) return '';
  var checkedRadio = form.querySelector('input[type="radio"][name="selling_plan"]:checked');
  if (checkedRadio) return String(checkedRadio.value || '').trim();
  var sel = form.querySelector('select[name="selling_plan"]');
  if (sel) return String(sel.value || '').trim();
  var hidden = form.querySelector('input[type="hidden"][name="selling_plan"]');
  if (hidden) return String(hidden.value || '').trim();
  return '';
}

/* ── Dynamic ATC price (variant + subscription + qty + addons) ── */
(function () {
  if (!document.querySelector('[data-atc-price]')) return;

  var fmt = new Intl.NumberFormat(Shopify.locale, {
    style: 'currency',
    currency: Shopify.currency.active
  });

  function getMainProductForm() {
    var el = document.querySelector('[data-atc-price]');
    return el ? el.closest('form') : document.querySelector('form[is="product-form"]');
  }

  function syncVariantPricingToDom(form, variant) {
    if (!form || !variant) return;
    var priceEl = form.querySelector('[data-atc-price]');
    if (!priceEl) return;

    var cents = typeof variant.price === 'number' ? variant.price : parseInt(variant.price, 10) || 0;
    var cmpRaw = variant.compare_at_price != null ? variant.compare_at_price : variant.compareAtPrice;
    var cmp = typeof cmpRaw === 'number' ? cmpRaw : parseInt(cmpRaw, 10);
    if (isNaN(cmp) || cmp <= cents) cmp = null;

    function applyVariantPricingAttrs(el) {
      el.setAttribute('data-unit-price', String(cents));
      el.setAttribute('data-unit-retail-cents', String(cents));
      if (cmp) el.setAttribute('data-unit-compare-cents', String(cmp));
      else el.removeAttribute('data-unit-compare-cents');
    }
    applyVariantPricingAttrs(priceEl);
    document.querySelectorAll('[data-atc-price]').forEach(function (ext) {
      if (ext !== priceEl) applyVariantPricingAttrs(ext);
    });
  }

  function getVariantsData(form) {
    var script = form && form.querySelector('script[data-selling-prices]');
    if (!script) return null;
    try { return JSON.parse(script.textContent.replace(/;\s*$/, '')); } catch (e) { return null; }
  }

  function getSellingPlanPrice(form, planId) {
    if (!planId) return undefined;
    var variants = getVariantsData(form);
    if (!variants) return undefined;
    var variantId = form.querySelector('input[name="id"]');
    var vid = variantId ? String(variantId.value) : '';
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === vid && variants[i].selling_plan_allocations) {
        for (var j = 0; j < variants[i].selling_plan_allocations.length; j++) {
          var alloc = variants[i].selling_plan_allocations[j];
          if (String(alloc.selling_plan_id) === planId) return alloc.price;
        }
      }
    }
    return undefined;
  }

  function getUnitPrice(form) {
    if (!form) return 0;
    var planId = ruggedDogProductFormSellingPlanId(form);
    if (planId) {
      var p = getSellingPlanPrice(form, planId);
      if (p !== undefined) return p;
    }
    var el = form.querySelector('[data-atc-price]');
    return el ? parseInt(el.getAttribute('data-unit-price'), 10) || 0 : 0;
  }

  function getQty(form) {
    var input =
      (form && form.querySelector('input[name="quantity"]')) ||
      document.querySelector('.product-info__inline-qty input[name="quantity"]');
    if (!input && form && form.id) {
      input = document.querySelector('input[name="quantity"][form="' + form.id + '"]');
    }
    return input ? parseInt(input.value, 10) || 1 : 1;
  }

  function getAddonsTotal() {
    var total = 0;
    document.querySelectorAll('.product-addons__checkbox:checked').forEach(function (cb) {
      total += parseInt(cb.getAttribute('data-addon-price'), 10) || 0;
    });
    return total;
  }

  function getAddonsCompareTotal() {
    var total = 0;
    document.querySelectorAll('.product-addons__checkbox:checked').forEach(function (cb) {
      var sale = parseInt(cb.getAttribute('data-addon-price'), 10) || 0;
      var cmpAttr = cb.getAttribute('data-addon-compare-price');
      var cmp = cmpAttr != null && cmpAttr !== '' ? parseInt(cmpAttr, 10) : NaN;
      if (!isNaN(cmp) && cmp > sale) total += cmp;
      else total += sale;
    });
    return total;
  }

  /** Per-unit strikethrough “was” price for the main line (compare_at if on sale, else retail). */
  function getMainStrikeUnitCents(form) {
    var el = form && form.querySelector('[data-atc-price]');
    if (!el) return 0;
    var retail = parseInt(el.getAttribute('data-unit-retail-cents'), 10);
    if (isNaN(retail)) retail = parseInt(el.getAttribute('data-unit-price'), 10) || 0;
    var cmpAttr = el.getAttribute('data-unit-compare-cents');
    var cmp = cmpAttr != null && cmpAttr !== '' ? parseInt(cmpAttr, 10) : NaN;
    if (!isNaN(cmp) && cmp > retail) return cmp;
    return retail;
  }

  function updateAtcPriceRoot(root, saleTotalCents, compareTotalCents) {
    var saleEl = root.querySelector('[data-atc-price-sale]');
    var compareEl = root.querySelector('[data-atc-price-compare]');
    var saleStr = fmt.format(saleTotalCents / 100);
    if (!saleEl) {
      root.textContent = saleStr;
      return;
    }
    saleEl.textContent = saleStr;
    if (compareEl) {
      if (compareTotalCents > saleTotalCents) {
        compareEl.textContent = fmt.format(compareTotalCents / 100);
        compareEl.hidden = false;
      } else {
        compareEl.textContent = '';
        compareEl.hidden = true;
      }
    }
  }

  function updateATCPrice(form) {
    form = form || getMainProductForm();
    if (!form) return;
    var root = form.querySelector('[data-atc-price]');
    if (!root) return;
    var qty = getQty(form);
    var mainSaleTotal = getUnitPrice(form) * qty;
    var mainCompareTotal = getMainStrikeUnitCents(form) * qty;
    var saleTotal = mainSaleTotal + getAddonsTotal();
    var compareTotal = mainCompareTotal + getAddonsCompareTotal();
    updateAtcPriceRoot(root, saleTotal, compareTotal);
    document.querySelectorAll('[data-atc-price]').forEach(function (ext) {
      if (ext !== root) updateAtcPriceRoot(ext, saleTotal, compareTotal);
    });
  }

  var productForm = getMainProductForm();
  updateATCPrice(productForm);

  function formForAtcTarget(el) {
    if (!el) return getMainProductForm();
    var f = el.form || (el.closest && el.closest('form'));
    if (f && f.querySelector('[data-atc-price]')) return f;
    return getMainProductForm();
  }

  document.addEventListener('change', function (e) {
    if (
      e.target.matches('input[name="quantity"]') ||
      e.target.matches('.product-addons__checkbox') ||
      e.target.matches('input[name="selling_plan"]') ||
      e.target.matches('select[name="selling_plan"]')
    ) {
      updateATCPrice(formForAtcTarget(e.target));
    }
  });

  document.addEventListener('input', function (e) {
    if (e.target.matches('input[name="quantity"]')) {
      updateATCPrice(formForAtcTarget(e.target));
    }
  });

  var spObserver = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var t = mutations[i].target;
      if (t.name === 'selling_plan' || t.name === 'properties[__foxsell:dynamic_add_on_bundle_id]' || (t.nodeType === 1 && t.querySelector && t.querySelector('[name="selling_plan"]'))) {
        updateATCPrice(getMainProductForm());
        return;
      }
    }
  });

  if (productForm) {
    spObserver.observe(productForm, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
  }

  document.addEventListener('variant:change', function (e) {
    var mapEl = document.querySelector('[data-bogo-texts]');
    if (mapEl && e.detail && e.detail.variant) {
      try {
        var map = JSON.parse(mapEl.textContent);
        var text = map[String(e.detail.variant.id)] || '';
        document.querySelectorAll('[data-bogo-badge]').forEach(function (badge) {
          badge.textContent = text;
          badge.hidden = !text;
        });
      } catch (err) {}
    }

    var form = e.target && e.target.closest ? e.target.closest('form') : getMainProductForm();
    if (!form || !e.detail || !e.detail.variant) {
      requestAnimationFrame(function () { updateATCPrice(getMainProductForm()); });
      return;
    }
    syncVariantPricingToDom(form, e.detail.variant);
    requestAnimationFrame(function () { updateATCPrice(form); });
  });
})();

/* ── Product Addons ── */
(function () {
  var container = document.querySelector('[data-product-addons]');
  if (!container) return;

  var formId = container.getAttribute('data-form-id');
  var form = document.getElementById(formId);
  if (!form) return;

  /* ── Add-to-cart interception (capture phase to fire before theme/Rebuy) ── */
  document.addEventListener('submit', function (e) {
    if (e.target !== form) return;

    var checkedBoxes = container.querySelectorAll('.product-addons__checkbox:checked');
    if (!checkedBoxes.length) return;

    e.preventDefault();
    e.stopPropagation();

    var mainVariantInput = form.querySelector('input[name="id"]');
    if (!mainVariantInput) return;

    var mainId = mainVariantInput.value;
    var quantityInput = form.querySelector('input[name="quantity"]');
    var mainQty = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

    function formLineProperties(formEl) {
      var props = {};
      if (!formEl || !formEl.querySelectorAll) return props;
      formEl.querySelectorAll('[name^="properties["]').forEach(function (input) {
        if (input.type === 'checkbox' || input.type === 'radio') {
          if (!input.checked) return;
        }
        var m = input.name && input.name.match(/^properties\[(.+)\]$/);
        if (!m) return;
        var raw = input.value != null ? String(input.value).trim() : '';
        if (!raw && input.type !== 'checkbox') return;
        props[m[1]] = raw;
      });
      return props;
    }

    function addonRowTitle(cb) {
      var row = cb.closest('.product-addons__item');
      if (!row) return '';
      var nameEl = row.querySelector('.product-addons__name');
      return nameEl ? nameEl.textContent.trim() : '';
    }

    var addonTitles = [];
    var addonVariantIds = [];
    checkedBoxes.forEach(function (cb) {
      addonVariantIds.push(String(cb.value));
      var t = addonRowTitle(cb);
      if (t) addonTitles.push(t);
    });

    var addonListNote = addonTitles.length
      ? addonTitles.join(', ').slice(0, 240)
      : addonVariantIds.join(',').slice(0, 240);

    var mainItem = {
      id: parseInt(mainId, 10),
      quantity: mainQty,
      properties: Object.assign({}, formLineProperties(form), {
        '_Includes add-ons': addonListNote,
        '_Add-on variant IDs': addonVariantIds.join(',')
      })
    };

    var spVal = ruggedDogProductFormSellingPlanId(form);
    if (spVal) {
      var spNum = parseInt(String(spVal).replace(/\D/g, ''), 10);
      if (!isNaN(spNum)) mainItem.selling_plan = spNum;
    }

    var items = [mainItem];
    checkedBoxes.forEach(function (cb) {
      var aid = parseInt(cb.value, 10);
      var rowTitle = addonRowTitle(cb);
      var addOnProps = {
        '_Product add-on': 'Yes',
        '_Bundled with parent variant': String(mainId)
      };
      if (rowTitle) addOnProps['_Add-on title'] = rowTitle.slice(0, 120);
      items.push({
        id: aid,
        quantity: 1,
        properties: addOnProps
      });
    });

    var submitButtons = Array.from(form.elements).filter(function (el) {
      return el.type === 'submit';
    });
    submitButtons.forEach(function (btn) { btn.setAttribute('aria-busy', 'true'); });

    var sectionsToBundle = ['variant-added'];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle }
      })
    );

    fetch(Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: items,
        sections: sectionsToBundle.join(','),
        sections_url: Shopify.routes.root + 'variants/' + mainId
      })
    })
      .then(function (response) {
        submitButtons.forEach(function (btn) { btn.removeAttribute('aria-busy'); });
        return response.json().then(function (json) {
          return { ok: response.ok, data: json };
        });
      })
      .then(function (result) {
        if (result.ok) {
          document.documentElement.dispatchEvent(
            new CustomEvent('product-addons:cart-add', {
              bubbles: true,
              detail: {
                parentVariantId: parseInt(mainId, 10),
                mainQuantity: mainQty,
                addonVariantIds: addonVariantIds.map(function (id) { return parseInt(id, 10); }),
                addonTitles: addonTitles.slice()
              }
            })
          );
          if (
            window.themeVariables.settings.cartType === 'page' ||
            window.themeVariables.settings.pageType === 'cart'
          ) {
            window.location.href = Shopify.routes.root + 'cart';
            return;
          }
          return fetch(Shopify.routes.root + 'cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cartContent) {
              cartContent.sections = result.data.sections;

              form.dispatchEvent(new CustomEvent('variant:add', {
                bubbles: true,
                detail: {
                  items: result.data.items || [result.data],
                  cart: cartContent
                }
              }));

              document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
                bubbles: true,
                detail: { baseEvent: 'variant:add', cart: cartContent }
              }));
            });
        } else {
          form.dispatchEvent(new CustomEvent('cart:error', {
            bubbles: true,
            detail: { error: result.data.description }
          }));
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      })
      .catch(function () {
        submitButtons.forEach(function (btn) { btn.removeAttribute('aria-busy'); });
      });
  }, true);
})();

/* ── Product Addon Popup ── */
(function () {
  var overlay = document.querySelector('[data-addon-popup-overlay]');
  if (!overlay) return;

  var popup = overlay.querySelector('[data-addon-popup]');
  var imgWrap = overlay.querySelector('[data-addon-popup-img-wrap]');
  var imgEl = overlay.querySelector('[data-addon-popup-img]');
  var titleEl = overlay.querySelector('[data-addon-popup-title-el]');
  var priceEl = overlay.querySelector('[data-addon-popup-price-el]');
  var descEl = overlay.querySelector('[data-addon-popup-desc-el]');
  var urlEl = overlay.querySelector('[data-addon-popup-url-el]');
  var mainEl = document.getElementById('main');

  function open(btn) {
    var title = btn.getAttribute('data-addon-popup-title') || '';
    var desc = btn.getAttribute('data-addon-popup-desc') || '';
    var image = btn.getAttribute('data-addon-popup-image') || '';
    var price = btn.getAttribute('data-addon-popup-price') || '';
    var comparePrice = btn.getAttribute('data-addon-popup-compare-price') || '';
    var url = btn.getAttribute('data-addon-popup-url') || '';

    titleEl.textContent = title;
    if (comparePrice) {
      priceEl.innerHTML = '<span class="product-addons__price--sale">' + price + '</span> <span class="product-addons__price--compare">' + comparePrice + '</span>';
    } else {
      priceEl.textContent = price;
    }
    descEl.innerHTML = desc;

    if (url && urlEl) {
      urlEl.href = url;
      urlEl.hidden = false;
    } else if (urlEl) {
      urlEl.hidden = true;
    }

    if (image) {
      imgEl.src = image;
      imgEl.alt = title;
      imgEl.style.display = '';
    } else {
      imgEl.style.display = 'none';
    }

    overlay.hidden = false;
    if (mainEl) { mainEl.style.position = 'relative'; mainEl.style.zIndex = '10'; }
    requestAnimationFrame(function () {
      overlay.classList.add('is-active');
    });
    document.body.style.overflow = 'hidden';
  }

  function close() {
    overlay.classList.remove('is-active');
    overlay.addEventListener('transitionend', function handler() {
      overlay.removeEventListener('transitionend', handler);
      overlay.hidden = true;
      if (mainEl) { mainEl.style.position = ''; mainEl.style.zIndex = ''; }
    });
    document.body.style.overflow = '';
  }

  document.querySelector('[data-product-addons]').addEventListener('click', function (e) {
    var btn = e.target.closest('.product-addons__info-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    open(btn);
  });

  overlay.querySelector('[data-addon-popup-close]').addEventListener('click', close);
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !overlay.hidden) close();
  });
})();

/* ── Standalone Free Shipping Bar ── */
(function () {
  var bar = document.querySelector('[data-standalone-shipping-bar]');
  if (!bar) return;

  var hasFreeShippingTag = bar.hasAttribute('data-free-shipping');
  var threshold = parseInt(bar.getAttribute('data-shipping-threshold'), 10) || 0;
  var msgTemplate = bar.getAttribute('data-shipping-message') || '';
  var successMsg = bar.getAttribute('data-shipping-success') || '';
  var hintMsg = bar.getAttribute('data-shipping-hint') || '';
  var fillEl = bar.querySelector('[data-standalone-shipping-fill]');
  var textEl = bar.querySelector('[data-standalone-shipping-text]');
  var hintEl = bar.querySelector('[data-standalone-shipping-hint]');
  var cartTotal = 0;

  if (!threshold && !hasFreeShippingTag) return;

  var fmt = new Intl.NumberFormat(Shopify.locale, {
    style: 'currency',
    currency: Shopify.currency.active
  });

  function getProductFormForBar() {
    var atc = document.querySelector('[data-atc-price]');
    return atc ? atc.closest('form') : document.querySelector('form[is="product-form"]');
  }

  function getBarSellingPlanPrice(form, planId) {
    if (!planId || !form) return undefined;
    var script = form.querySelector('script[data-selling-prices]');
    if (!script) return undefined;
    try {
      var variants = JSON.parse(script.textContent.replace(/;\s*$/, ''));
      var variantInput = form.querySelector('input[name="id"]');
      var vid = variantInput ? String(variantInput.value) : '';
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === vid && variants[i].selling_plan_allocations) {
          for (var j = 0; j < variants[i].selling_plan_allocations.length; j++) {
            var alloc = variants[i].selling_plan_allocations[j];
            if (String(alloc.selling_plan_id) === planId) return alloc.price;
          }
        }
      }
    } catch (e) {}
    return undefined;
  }

  function getProductPrice() {
    var form = getProductFormForBar();
    var atcEl = form ? form.querySelector('[data-atc-price]') : document.querySelector('[data-atc-price]');
    if (atcEl && form) {
      var planId = ruggedDogProductFormSellingPlanId(form);
      if (planId) {
        var cents = getBarSellingPlanPrice(form, planId);
        if (cents !== undefined) return cents;
      }
      return parseInt(atcEl.getAttribute('data-unit-price'), 10) || 0;
    }
    return parseInt(bar.getAttribute('data-product-price'), 10) || 0;
  }

  function getQty() {
    var input = document.querySelector('.product-info__inline-qty input[name="quantity"]');
    return input ? parseInt(input.value, 10) || 1 : 1;
  }

  function getAddonsTotal() {
    var total = 0;
    document.querySelectorAll('.product-addons__checkbox:checked').forEach(function (cb) {
      total += parseInt(cb.getAttribute('data-addon-price'), 10) || 0;
    });
    return total;
  }

  function hasUncheckedAddons() {
    return document.querySelectorAll('.product-addons__checkbox:not(:checked)').length > 0;
  }

  function update() {
    if (!fillEl || !textEl) return;

    if (hasFreeShippingTag) {
      fillEl.style.width = '100%';
      textEl.innerHTML = successMsg;
      bar.classList.add('shipping-bar--complete');
      if (hintEl) hintEl.hidden = true;
      bar.style.display = '';
      return;
    }

    var projected = cartTotal + (getProductPrice() * getQty()) + getAddonsTotal();
    var pct = Math.min((projected / threshold) * 100, 100);
    var remaining = threshold - projected;

    fillEl.style.width = pct + '%';

    if (remaining <= 0) {
      textEl.innerHTML = successMsg;
      bar.classList.add('shipping-bar--complete');
      if (hintEl) hintEl.hidden = true;
    } else {
      var formatted = fmt.format(remaining / 100);
      textEl.innerHTML = msgTemplate.replace('{amount}', '<strong>' + formatted + '</strong>');
      bar.classList.remove('shipping-bar--complete');
      if (hintEl && hintMsg) {
        hintEl.textContent = hintMsg;
        hintEl.hidden = !hasUncheckedAddons();
      }
    }

    bar.style.display = '';
  }

  function refreshCartAndUpdate() {
    fetch(Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartTotal = cart.total_price || 0;
        update();
      })
      .catch(function () { update(); });
  }

  refreshCartAndUpdate();

  document.addEventListener('change', function (e) {
    if (
      e.target.matches('input[name="quantity"]') ||
      e.target.matches('.product-addons__checkbox') ||
      e.target.matches('input[name="selling_plan"]') ||
      e.target.matches('select[name="selling_plan"]')
    ) {
      update();
    }
  });
  document.addEventListener('input', function (e) {
    if (e.target.matches('input[name="quantity"]')) update();
  });

  document.addEventListener('variant:change', function () {
    requestAnimationFrame(update);
  });

  document.addEventListener('foxsell:change', function () {
    update();
  })

  document.documentElement.addEventListener('cart:change', function (e) {
    cartTotal = (e.detail && e.detail.cart) ? e.detail.cart.total_price || 0 : cartTotal;
    update();
  });
  
  document.addEventListener('cart:refresh', refreshCartAndUpdate);
  document.addEventListener('cart:external-change', function (e) {
    cartTotal = (e.detail && e.detail.cart) ? e.detail.cart.total_price || 0 : cartTotal;
    update();
  });
})();

/* ── Pack cards: show subscription price when a selling plan is active ── */
(function () {
  var fmt = new Intl.NumberFormat(Shopify.locale, {
    style: 'currency',
    currency: Shopify.currency.active
  });

  function getSellingPlanId() {
    var form = document.querySelector('form[is="product-form"]');
    if (!form) return '';
    var el = form.querySelector('input[name="selling_plan"]');
    return el ? String(el.value || '').trim() : '';
  }

  function updateCards() {
    var cards = document.querySelectorAll('label.pack-option-card[data-variant-base-price]');
    if (!cards.length) return;
    var planId = getSellingPlanId();
    cards.forEach(function (card) {
      var base = parseInt(card.getAttribute('data-variant-base-price'), 10) || 0;
      var divisor = parseInt(card.getAttribute('data-pack-unit-divisor'), 10) || 1;
      var suffix = card.getAttribute('data-unit-suffix') || '';
      var cents = base;

      if (planId) {
        try {
          var map = JSON.parse(card.getAttribute('data-selling-plan-prices'));
          if (map[planId] != null) cents = parseInt(map[planId], 10);
        } catch (e) {}
      }

      var totalEl = card.querySelector('.pack-option-card__total');
      var unitEl = card.querySelector('.pack-option-card__unit');
      if (totalEl) totalEl.textContent = fmt.format(cents / 100);
      if (unitEl) unitEl.textContent = fmt.format(Math.floor(cents / divisor) / 100) + suffix;
    });
  }

  var lastPlanId = '';
  function checkAndUpdate() {
    var current = getSellingPlanId();
    if (current !== lastPlanId) {
      lastPlanId = current;
      updateCards();
    }
  }

  document.addEventListener('change', function (e) {
    if (e.target.matches('input[name="selling_plan"]')) {
      lastPlanId = getSellingPlanId();
      updateCards();
    }
  });
  document.addEventListener('variant:change', function () {
    setTimeout(updateCards, 50);
    setTimeout(updateCards, 300);
  });

  var rcWidget = document.querySelector('recharge-subscription-widget, .recharge-subscription-widget');
  if (rcWidget) {
    rcWidget.addEventListener('click', function () {
      setTimeout(checkAndUpdate, 150);
    });
  }

  updateCards();
  lastPlanId = getSellingPlanId();
  setTimeout(function () { lastPlanId = getSellingPlanId(); updateCards(); }, 500);
  setTimeout(function () { lastPlanId = getSellingPlanId(); updateCards(); }, 1500);
  window.addEventListener('load', function () {
    setTimeout(function () { lastPlanId = getSellingPlanId(); updateCards(); }, 300);
  });
})();

/* ── Mobile sticky ATC: show on land, hide while main ATC is on screen,
      show again after scrolling past it. Desktop is left to the theme. ── */
(function () {
  var MOBILE_MQ = window.matchMedia('(max-width: 699px)');
  var PASS_OFFSET = 140; // px above viewport top before sticky reappears
  var APPROACH_OFFSET = 64; // px below viewport bottom to start hiding
  var nativeToggle = DOMTokenList.prototype.toggle;

  function getMainAtcZone() {
    return document.querySelector('.product-info__qty-atc-row');
  }

  function isFooterVisible() {
    var footer = document.querySelector('.shopify-section--footer, .footer');
    return !!footer && footer.getBoundingClientRect().top < window.innerHeight;
  }

  function updateSticky(sticky) {
    if (!sticky || !MOBILE_MQ.matches) return;

    var zone = getMainAtcZone();
    if (!zone) return;

    var rect = zone.getBoundingClientRect();
    var atcInRange = rect.bottom > PASS_OFFSET && rect.top < window.innerHeight + APPROACH_OFFSET;
    var show = !atcInRange && !isFooterVisible();
    if (show) DOMTokenList.prototype.add.call(sticky.classList, 'is-visible');
    else DOMTokenList.prototype.remove.call(sticky.classList, 'is-visible');
  }

  function updateAll() {
    if (!MOBILE_MQ.matches) return;
    document.querySelectorAll('product-quick-add').forEach(updateSticky);
  }

  var ticking = false;
  function scheduleUpdate() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      updateAll();
    });
  }

  function setup(el) {
    if (!el || el.dataset.ruggedStickyAtc === '1') return;
    el.dataset.ruggedStickyAtc = '1';

    // Theme's own observer tries to show/hide the bar too. On mobile, ignore
    // its toggle and re-sync from our scroll logic instead.
    el.classList.toggle = function (token, force) {
      if (token === 'is-visible' && MOBILE_MQ.matches) {
        updateSticky(el);
        return this.contains(token);
      }
      return nativeToggle.call(this, token, force);
    };

    updateSticky(el);
  }

  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', scheduleUpdate);
  document.addEventListener('variant:change', function () {
    setTimeout(updateAll, 50);
    setTimeout(updateAll, 300);
  });

  function initAll() {
    document.querySelectorAll('product-quick-add').forEach(setup);
    updateAll();
  }

  initAll();

  // product-rerender can replace the sticky bar on variant change
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches('product-quick-add')) setup(node);
        else if (node.querySelectorAll) node.querySelectorAll('product-quick-add').forEach(setup);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* ── Size chart image modal ── */
(function () {
  function getDialog(btn) {
    var id = btn && btn.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-size-chart-modal-open]');
    if (openBtn) {
      var dialog = getDialog(openBtn);
      if (dialog && dialog.showModal) {
        dialog.showModal();
        openBtn.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    var dialog = e.target.closest('[data-size-chart-modal]');
    if (dialog && e.target === dialog) dialog.close();
  });

  document.addEventListener('close', function (e) {
    if (!e.target.matches || !e.target.matches('[data-size-chart-modal]')) return;
    var id = e.target.id;
    var btn = document.querySelector('[data-size-chart-modal-open][aria-controls="' + id + '"]');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }, true);
})();

;(() => {
  if (window.__rdcChatBrandV1) return;
  window.__rdcChatBrandV1 = true;
  const logo = 'https://cdn.shopify.com/s/files/1/0984/6436/6868/files/rdc-brand-primary-color-2026.png?v=1792003839';
  const watermark = 'https://cdn.shopify.com/s/files/1/0984/6436/6868/files/rdc-timber-field-dog-watermark.png?v=1792016365';
  const fontFace = "@font-face{font-family:\"RDC Bourbon Headings\";src:url(\"data:font/woff;base64,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\") format(\"woff\");font-weight:400;font-style:normal;font-display:swap}";
  const fontStyle = document.createElement('style');
  fontStyle.id = 'rdc-chat-heading-font';
  fontStyle.textContent = fontFace;
  document.head.append(fontStyle);
  const css = `
  [role="dialog"]:is([aria-label="AI chat"],[aria-label="Chat window"]) { background:#33402f!important; color:#fff!important; font-family:Rubik,Arial,sans-serif!important; }
  [role="dialog"]:is([aria-label="AI chat"],[aria-label="Chat window"]) > header { background:#c3c0ad!important; color:#33402f!important; min-height:112px; gap:8px; }
  [role="dialog"]:is([aria-label="AI chat"],[aria-label="Chat window"]) > header > div:first-of-type,
  [role="dialog"]:is([aria-label="AI chat"],[aria-label="Chat window"]) > header > div:nth-of-type(2) { display:none!important; }
  .rdc-chat-full-logo { display:block!important; width:200px; height:114px; object-fit:contain; margin-right:auto; flex:none; }
  [role="dialog"]:is([aria-label="AI chat"],[aria-label="Chat window"]) [role="log"] { position:relative; isolation:isolate; background:#33402f!important; color:white!important; }
  [role="dialog"]:is([aria-label="AI chat"],[aria-label="Chat window"]) [role="log"]::before { content:""; position:absolute; inset:0; background:url("${watermark}") 90% center / 86% auto no-repeat; opacity:.22; pointer-events:none; z-index:-1; }
  [role="dialog"]:is([aria-label="AI chat"],[aria-label="Chat window"]) [role="log"] :is(.text-am-ink,.am-markdown,.text-gray-500,.text-am-faint,[data-chat-message-time]) { color:white!important; }
  [role="dialog"]:is([aria-label="AI chat"],[aria-label="Chat window"]) [role="log"] h2 { font-family:"RDC Bourbon Headings",Impact,sans-serif!important; font-size:30px!important; line-height:1.15!important; font-weight:400!important; }
  [role="dialog"]:is([aria-label="AI chat"],[aria-label="Chat window"]) [role="log"] a { color:#c3c0ad!important; text-decoration:underline; }
  [role="dialog"]:is([aria-label="AI chat"],[aria-label="Chat window"]) [role="log"] button:not([aria-label]):not([aria-pressed]) { background:#f4f2e9!important; color:#33402f!important; border:1px solid #c3c0ad!important; min-height:44px; font-weight:700!important; }
  [role="dialog"]:is([aria-label="AI chat"],[aria-label="Chat window"]) [role="log"] button:not([aria-label]):not([aria-pressed]) svg { color:#c37535!important; }
  [role="dialog"]:is([aria-label="AI chat"],[aria-label="Chat window"]) [role="log"] button:hover { filter:brightness(1.08); }
  [role="dialog"]:is([aria-label="AI chat"],[aria-label="Chat window"]) form { background:#33402f!important; }
  [role="dialog"]:is([aria-label="AI chat"],[aria-label="Chat window"]) form > div { background:#f4f2e9!important; }
  [role="dialog"]:is([aria-label="AI chat"],[aria-label="Chat window"]) textarea { color:#1f2320!important; font-family:Rubik,Arial,sans-serif!important; font-size:16px!important; }
  [role="dialog"]:is([aria-label="AI chat"],[aria-label="Chat window"]) button[aria-label="Send message"]:not(:disabled) { background:#c37535!important; color:#1f2320!important; }
  [role="dialog"]:is([aria-label="AI chat"],[aria-label="Chat window"]) form > p { color:#c3c0ad!important; background:#33402f!important; }
  [role="dialog"]:is([aria-label="AI chat"],[aria-label="Chat window"]) form > p a { color:#fff!important; }
  button[aria-label="Open AI chat"],button[aria-label="Open chat"] { min-width:60px!important; min-height:60px!important; width:60px!important; height:60px!important; border:2px solid #c3c0ad!important; box-shadow:0 4px 18px #1f232050!important; }
  button:focus-visible { outline:3px solid #c37535!important; outline-offset:3px!important; }
  @media(max-width:767px) {
    [role="dialog"]:is([aria-label="AI chat"],[aria-label="Chat window"]) > header { min-height:94px; padding:8px 12px!important; }
    .rdc-chat-full-logo { width:176px; height:100px; }
    button[aria-label="Open AI chat"],button[aria-label="Open chat"] { width:56px!important; height:56px!important; min-width:56px!important; min-height:56px!important; }
  }
  @media(prefers-reduced-motion:reduce) { button[aria-label="Open AI chat"],button[aria-label="Open chat"] { animation:none!important; } }

  /* Shared palette for all visitor-facing widget components. */
  #agentmatica-widget-root {
    --am-font:Rubik,Arial,sans-serif!important;
    --am-surface:#33402f!important; --am-ink:#ffffff!important;
    --am-muted:#c3c0ad!important; --am-faint:#c3c0ad!important;
    --am-brand:#c37535!important; --am-on-brand:#1f2320!important;
    --am-accent:#c37535!important; --am-accent-soft:#f4f2e9!important;
    --am-accent-text:#33402f!important; --am-on-accent:#1f2320!important;
    --am-user-bubble:#576237!important; --am-on-user-bubble:#ffffff!important;
    --am-line:#c3c0ad55!important; --am-line-strong:#c3c0ad99!important;
  }
  [role="dialog"]:is([aria-label="AI chat"],[aria-label="Chat window"]) :is(button,input,textarea,select) { font-family:Rubik,Arial,sans-serif!important; }
  [role="dialog"]:is([aria-label="AI chat"],[aria-label="Chat window"]) :is(h1,h2,h3),
  [role="dialog"]:is([aria-label="AI chat"],[aria-label="Chat window"]) [role="log"]:not(:has([data-chat-message])) p.whitespace-pre-wrap { font-family:"RDC Bourbon Headings",Impact,sans-serif!important; font-size:28px!important; font-weight:400!important; line-height:1.2!important; }
  [role="dialog"]:is([aria-label="AI chat"],[aria-label="Chat window"]) > header button { color:#33402f!important; width:44px!important; height:44px!important; opacity:1!important; }
  [role="dialog"]:is([aria-label="AI chat"],[aria-label="Chat window"]) [role="group"][aria-label="Rate this reply"] button { color:#c3c0ad!important; min-width:36px; min-height:36px; }
  [role="dialog"]:is([aria-label="AI chat"],[aria-label="Chat window"]) textarea { background:transparent!important; }
  [role="dialog"]:is([aria-label="AI chat"],[aria-label="Chat window"]) textarea::placeholder { color:#576237!important; opacity:1!important; }
  button:is([aria-label="Open chat"],[aria-label="Open AI chat"],[aria-label="Close chat"]) { background:#33402f!important; color:#ffffff!important; }

  [role="dialog"]:is([aria-label="AI chat"],[aria-label="Chat window"]) .am-markdown { font-size:16px!important; line-height:1.5!important; }
  [role="dialog"]:is([aria-label="AI chat"],[aria-label="Chat window"]) [role="log"] button:not([aria-label]):not([aria-pressed]) { font-size:15px!important; line-height:1.4!important; }
  [role="dialog"]:is([aria-label="AI chat"],[aria-label="Chat window"]) form > p { font-size:12px!important; line-height:1.5!important; }

  [role="dialog"][aria-label="Past chats"] { top:138px!important; background:#33402f!important; color:#fff!important; }
  [role="dialog"][aria-label="Past chats"] > div:first-child { position:relative; z-index:1; background:#c3c0ad!important; border-color:#576237!important; gap:8px; }
  [role="dialog"][aria-label="Past chats"] h3 { color:#33402f!important; font-family:"RDC Bourbon Headings",Impact,sans-serif!important; font-size:26px!important; }
  [role="dialog"][aria-label="Past chats"] > div:first-child button { min-height:44px!important; min-width:44px!important; color:#33402f!important; font-size:15px!important; }
  [role="dialog"][aria-label="Past chats"] > div:first-child button:not([aria-label]) { background:#c37535!important; color:#1f2320!important; }
  [role="dialog"][aria-label="Past chats"] .am-scroll-pane { position:relative; z-index:1; }
  [role="dialog"][aria-label="Past chats"]::before { content:""; position:absolute; inset:64px 0 0; background:url("https://cdn.shopify.com/s/files/1/0984/6436/6868/files/rdc-timber-field-dog-watermark.png?v=1792016365") 90% center / 86% auto no-repeat; opacity:.22; pointer-events:none; }
  [role="dialog"][aria-label="Past chats"] li button { min-height:60px; border:1px solid #c3c0ad55; margin-bottom:6px; background:#57623755; }
  [role="dialog"][aria-label="Past chats"] li button:hover { background:#576237!important; }
  [role="dialog"][aria-label="Past chats"] li .text-gray-900 { color:#fff!important; font-size:16px!important; }
  [role="dialog"][aria-label="Past chats"] :is(.text-gray-500,.text-gray-700) { color:#c3c0ad!important; }
  @media(max-width:767px) { [role="dialog"][aria-label="Past chats"] { top:calc(116px + env(safe-area-inset-top,0px))!important; } }

  [role="dialog"]:is([aria-label="AI chat"],[aria-label="Chat window"]) [role="log"] {
    background-image:linear-gradient(rgba(51,64,47,.78),rgba(51,64,47,.78)),url("https://cdn.shopify.com/s/files/1/0984/6436/6868/files/rdc-timber-field-dog-watermark.png?v=1792016365")!important;
    background-size:100% 100%,86% auto!important;
    background-position:center,90% center!important;
    background-repeat:no-repeat!important;
    background-attachment:scroll!important;
  }
  [role="dialog"]:is([aria-label="AI chat"],[aria-label="Chat window"]) [role="log"]::before { display:none!important; }

  #agentmatica-widget-root { font-family:Rubik,Arial,sans-serif!important; }
  #agentmatica-widget-root :is([role="log"],.am-markdown,button,input,textarea,select,footer,[role="dialog"][aria-label="Past chats"]) { font-family:Rubik,Arial,sans-serif!important; letter-spacing:.01em; }
  #agentmatica-widget-root .am-markdown { font-size:16px!important; line-height:1.55!important; font-weight:400; }
  #agentmatica-widget-root .bg-am-accent-soft { color:#33402f!important; }

  `;
  let attempts=0;
  const timer=setInterval(() => {
    const root=document.querySelector('#agentmatica-widget-wrapper')?.shadowRoot;
    if (!root) { if (++attempts>150) clearInterval(timer); return; }
    clearInterval(timer);
    const style=document.createElement('style');
    style.id='rdc-chat-brand-v1'; style.textContent=css; root.append(style);
    let scheduled=false;
    const decorate=() => {
      scheduled=false;
      const header=root.querySelector('[role="dialog"]:is([aria-label="AI chat"],[aria-label="Chat window"]) > header');
      if (header && !header.querySelector('.rdc-chat-full-logo')) {
        const image=document.createElement('img'); image.className='rdc-chat-full-logo'; image.src=logo; image.alt='Rugged Dog Company'; image.width=176; image.height=100; header.prepend(image);
      }
    };
    const observer=new MutationObserver(() => { if(!scheduled) { scheduled=true; requestAnimationFrame(decorate); } });
    observer.observe(root,{childList:true,subtree:true}); decorate();
  },400);
})();


/* RDC chat preview guard: one compact invitation, no unread-message stacks. */

/* ──────────────────────────────────────────────────────────────────────
   DISABLED 2026-10-23: RDC chat preview guard.
   It hid every Agentmatica message card (leaving only the unread "1"
   badge) and showed its own bubble once per session, so page nudges never
   appeared. The widget now limits cards itself: one at a time, at most
   one per page and two per visit (Agentmatica #288). Brand styling lives in
   the __rdcChatBrandV1 block above and is not affected.

(() => {
  const key = 'rdc-chat-preview-v1';
  let root, preview, timer, consumed = false, attempts = 0;
  const wasSeen = () => { try { return sessionStorage.getItem(key) === 'seen'; } catch (_) { return consumed; } };
  const remember = () => { consumed = true; try { sessionStorage.setItem(key, 'seen'); } catch (_) {} };
  const removePreview = () => { if (preview) { preview.remove(); preview = null; } };
  const blockedPage = () => /^\/(cart|checkout|checkouts|account)(\/|$)/.test(location.pathname);
  const chatOpen = () => !!root.querySelector('[role="dialog"][aria-label="Chat window"],[role="dialog"][aria-label="AI chat"]');
  function tidy() {
    root.querySelectorAll('button[aria-label^="Open chat: new message"]').forEach(button => {
      let card = button.parentElement;
      while (card && card !== root) {
        if (card.querySelector('button[aria-label="Dismiss notification"]') &&
            !card.querySelector('.am-launcher-frame') &&
            !card.querySelector('[role="dialog"]')) {
          card.classList.add('rdc-quiet-notification');
        }
        card = card.parentElement;
      }
      button.classList.add('rdc-quiet-notification');
    });
    root.querySelectorAll('button').forEach(button => {
      const text = button.textContent.trim();
      if (text === 'Show less' || /^\d+ more$/.test(text) ||
          button.getAttribute('aria-label') === 'Dismiss notification') {
        button.classList.add('rdc-quiet-notification');
      }
    });
    if (chatOpen()) { remember(); removePreview(); }
    if (blockedPage()) removePreview();
  }
  function show() {
    if (consumed || wasSeen() || blockedPage() || chatOpen()) return;
    if (document.visibilityState !== 'visible') {
      document.addEventListener('visibilitychange', function visible() {
        if (document.visibilityState === 'visible') {
          document.removeEventListener('visibilitychange', visible);
          timer = setTimeout(show, 10000);
        }
      });
      return;
    }
    const path = location.pathname.toLowerCase();
    let text = 'Need help finding the right chew or toy?';
    if (/bully|cheek|yak|chews/.test(path)) text = 'Need help choosing a chew or pack size?';
    else if (/harness|collar|leash|gear/.test(path)) text = 'Need help with sizing or matching gear?';
    else if (/toy|goughnuts|monster-k9|sodapup/.test(path)) text = 'Need help choosing a toy or a good pairing?';
    else if (/shipping|returns|refund|contact|faq/.test(path)) text = 'Questions about shipping, returns or your order?';
    else if (/blog/.test(path)) text = 'Questions about what you’re reading? Ask us.';
    preview = document.createElement('div');
    preview.className = 'rdc-quiet-preview';
    const ask = document.createElement('button');
    ask.type = 'button'; ask.className = 'rdc-quiet-preview-ask';
    ask.textContent = text; ask.setAttribute('aria-label', text + ' Open chat');
    const close = document.createElement('button');
    close.type = 'button'; close.className = 'rdc-quiet-preview-close';
    close.textContent = '×'; close.setAttribute('aria-label', 'Dismiss help preview');
    ask.addEventListener('click', () => {
      const launcher = root.querySelector('.am-launcher-frame button[aria-expanded="false"]');
      remember(); removePreview(); if (launcher) launcher.click();
    });
    close.addEventListener('click', () => { remember(); removePreview(); });
    preview.append(ask, close);
    root.append(preview);
    remember();
  }
  const wait = setInterval(() => {
    root = document.querySelector('#agentmatica-widget-wrapper')?.shadowRoot;
    if (!root) { if (++attempts >= 150) clearInterval(wait); return; }
    clearInterval(wait);
    if (root.querySelector('#rdc-chat-preview-guard')) return;
    const style = document.createElement('style');
    style.id = 'rdc-chat-preview-guard';
    style.textContent = `
      .rdc-quiet-notification, #agentmatica-widget-root div:has(button[aria-label^="Open chat: new message"]):not(:has(.am-launcher-frame)):not(:has([role="dialog"])) { display:none!important; pointer-events:none!important; }
      .rdc-quiet-preview { position:fixed; right:24px; bottom:94px; z-index:2147483647;
        display:flex; align-items:center; max-width:min(280px,calc(100vw - 48px));
        background:#33402f; color:#fff; border:1px solid #c3c0ad;
        border-radius:14px; box-shadow:0 4px 16px #0002; pointer-events:auto;
        font-family:Rubik,Arial,sans-serif; }
      .rdc-quiet-preview-ask { padding:12px 8px 12px 14px; border:0; background:transparent;
        color:inherit; text-align:left; font:500 14px/1.4 Rubik,Arial,sans-serif; cursor:pointer; }
      .rdc-quiet-preview-close { flex:0 0 44px; align-self:stretch; min-height:44px;
        padding:0; border:0; border-radius:0 14px 14px 0; background:transparent;
        color:#c3c0ad; font:24px/1 Arial,sans-serif; cursor:pointer; }
      .rdc-quiet-preview button:focus-visible { outline:2px solid #c37535; outline-offset:2px; }
      @media(max-width:767px) { .rdc-quiet-preview { right:16px; bottom:90px; max-width:min(260px,calc(100vw - 32px)); } }
    `;
    root.append(style);
    let scheduled = false;
    new MutationObserver(() => {
      if (!scheduled) { scheduled = true; requestAnimationFrame(() => { scheduled = false; tidy(); }); }
    }).observe(root, { childList:true, subtree:true });
    tidy();
    if (!wasSeen() && !blockedPage()) timer = setTimeout(show, 30000);
  }, 200);
})();

   END DISABLED RDC chat preview guard
   ────────────────────────────────────────────────────────────────────── */